
// import React, { useState } from 'react';

// // Import your team member images here (Replace with your actual paths)
// import memberImg1 from '../Assets/Team/suhani3.jpeg';
// import memberImg2 from '../Assets/Team/shraddha.jpeg';
// import memberImg3 from '../Assets/Team/nakhat3.jpeg';
// // import memberImg4 from '../Assets/FOUNDER.jpeg';

// const MeetOurTeam = () => {
//     const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
//     const [isVisible, setIsVisible] = useState(false);
//     const [openForm, setOpenForm] = useState(false);
//     const theme = {
//         background: '#F8F6F2',
//         surface: '#FFFFFF',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#7A827E',
//         border: 'rgba(44, 48, 46, 0.08)',
//         glass: 'rgba(255, 255, 255, 0.7)'
//     };

//     const teamMembers = [
//         {
//             name: "Suhani Jain",
//             role: "Interior Designer",
//             image: memberImg1,
//             description: "Visionary designer steering the studio's spatial curation and artistic direction."
//         },
//         {
//             name: "Shraddha Agrawal",
//             role: "Interior Designer",
//             image: memberImg2,
//             description: "Specialist in bespoke furniture engineering and structural spatial harmony."
//         },
//         {
//             name: "Nakhat Giri",
//             role: "Site Supervisor",
//             image: memberImg3,
//             description: "Master of operational execution, translating blueprint concepts into immaculate reality."
//         },

//     ];

//     const inputStyle = {
//         width: "100%",
//         padding: "12px 16px",
//         borderRadius: "12px",
//         border: `1px solid ${theme.border}`,
//         outline: "none",
//         fontSize: "14px",
//         background: theme.background,
//         color: theme.textMain,
//         boxSizing: "border-box",
//         transition: "border-color 0.3s, box-shadow 0.3s",
//         fontFamily: "inherit"
//     };
//     const inlineStyles = {

//         pillBtn: {
//             padding: '14px 40px',
//             fontSize: '1rem',
//             fontWeight: '600',
//             color: '#FFFFFF',
//             backgroundColor: '#2C302E',
//             border: 'none',
//             borderRadius: '30px',
//             cursor: 'pointer',
//             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
//             transition: 'all 0.2s ease',
//             outline: 'none',
//             textTransform: 'uppercase',
//             letterSpacing: '1px',
//             display: 'inline-block',
//             fontFamily: "'Cinzel', Georgia, serif",
//         }
//     };
//     const responsiveStyles = `
//         /* Dynamic import of the luxury Roman serif font */
//         @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&display=swap');

//         @keyframes revealUp {
//             from { opacity: 0; transform: translateY(50px); }
//             to { opacity: 1; transform: translateY(0); }
//         }
//         .team-animate-entry { 
//             animation: revealUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
//         }

//         /* ==================== SCREEN RESPONSIVENESS ==================== */
//         @media (max-width: 991px) {
//             .team-grid-container {
//                 grid-template-columns: 1fr !important;
//                 gap: 50px !important;
//                 padding: 0 20px !important;
//             }
//             .team-card-wrapper {
//                 margin-top: 0 !important;
//                 transform: none !important;
//             }
//             .team-title-main {
//                 font-size: 2.2rem !important;
//                 letter-spacing: 4px !important;
//             }
//             .team-image-frame {
//                 height: 400px !important;
//             }
//         }
//     `;

//     return (
//         <section id="team" style={{
//             width: '100vw',
//             minHeight: '100vh',
//             background: theme.background,
//             padding: '160px 0 100px 0',
//             boxSizing: 'border-box',
//             overflowX: 'hidden',
//             fontFamily: "'Cinzel', Georgia, serif"
//         }}>
//             <style>{responsiveStyles}</style>

//             {/* ==================== EDITORIAL SECTION HEADER ==================== */}
//             <div className="team-animate-entry" style={{
//                 textAlign: 'center',
//                 marginBottom: '90px',
//                 padding: '0 20px'
//             }}>
//                 <span style={{
//                     fontFamily: 'system-ui, -apple-system, sans-serif',
//                     fontSize: '0.85rem',
//                     fontWeight: '600',
//                     textTransform: 'uppercase',
//                     letterSpacing: '4px',
//                     color: theme.accent,
//                     display: 'block',
//                     marginBottom: '12px'
//                 }}>
//                     The Creative Minds
//                 </span>
//                 <h2 className="team-title-main" style={{
//                     fontSize: 'calc(0.3rem + 1.5vw)',
//                     fontWeight: '400',
//                     textTransform: 'uppercase',
//                     letterSpacing: '6px',
//                     color: theme.textMain,
//                     margin: 0
//                 }}>
//                     Meet Our Team
//                 </h2>
//                 <div style={{
//                     width: '60px',
//                     height: '1px',
//                     background: theme.accent,
//                     margin: '24px auto 0 auto'
//                 }} />
//             </div>

//             {/* ==================== ASYMMETRIC STAGGERED GRID ==================== */}
//             <div className="team-grid-container" style={{
//                 display: 'grid',
//                 gridTemplateColumns: 'repeat(3, 1fr)',
//                 gap: '30px',
//                 width: '100%',
//                 maxWidth: '1400px',
//                 margin: '0 auto',
//                 padding: '0 40px',
//                 boxSizing: 'border-box'
//             }}>
//                 {teamMembers.map((member, index) => {
//                     const isHovered = hoveredCardIndex === index;

//                     const isEvenColumn = index % 2 === 1;
//                     const topOffset = isEvenColumn ? '60px' : '0px';

//                     return (
//                         <div
//                             key={index}
//                             className="team-card-wrapper team-animate-entry"
//                             onMouseEnter={() => setHoveredCardIndex(index)}
//                             onMouseLeave={() => setHoveredCardIndex(null)}
//                             style={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 marginTop: topOffset,
//                                 transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
//                                 transform: isHovered ? 'translateY(-10px)' : 'translateY(0)',
//                                 animationDelay: `${index * 0.15}s`
//                             }}
//                         >
//                             {/* Image Showcase Container */}
//                             <div className="team-image-frame" style={{
//                                 width: '100%',
//                                 height: '480px',
//                                 overflow: 'hidden',
//                                 position: 'relative',
//                                 border: `1px solid ${isHovered ? theme.accent : theme.border}`,
//                                 transition: 'border-color 0.4s ease',
//                                 background: '#F5F5F5'
//                             }}>
//                                 <img
//                                     src={member.image}
//                                     alt={member.name}
//                                     style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                         transition: 'transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
//                                         transform: isHovered ? 'scale(1.05)' : 'scale(1)'
//                                     }}
//                                 />

//                                 <div style={{
//                                     position: 'absolute',
//                                     bottom: 0,
//                                     left: 0,
//                                     width: '100%',
//                                     height: '4px',
//                                     background: theme.accent,
//                                     transform: isHovered ? 'scaleX(1)' : 'scaleX(0)',
//                                     transformOrigin: 'left',
//                                     transition: 'transform 0.4s ease'
//                                 }} />
//                             </div>

//                             {/* Info Block Details */}
//                             <div style={{
//                                 padding: '24px 4px 0 4px',
//                                 textAlign: 'left'
//                             }}>
//                                 {/* Matched Typography to User Image Reference */}
//                                 <h3 style={{
//                                     fontFamily: "'Cinzel', Georgia, serif",
//                                     fontSize: '1.35rem',
//                                     fontWeight: '400',
//                                     textTransform: 'uppercase',
//                                     color: theme.textMain,
//                                     margin: '0 0 6px 0',
//                                     letterSpacing: '3px' // Spaced luxury alignment
//                                 }}>
//                                     {member.name}
//                                 </h3>

//                                 <span style={{
//                                     fontFamily: "'Cinzel', Georgia, serif",
//                                     fontSize: '0.8rem',
//                                     fontWeight: '500',
//                                     textTransform: 'uppercase',
//                                     letterSpacing: '2px',
//                                     color: theme.accent,
//                                     display: 'block',
//                                     marginBottom: '14px'
//                                 }}>
//                                     {member.role}
//                                 </span>

//                                 {/* <p style={{
//                                     // fontFamily: 'system-ui, -apple-system, sans-serif',
//                                     fontFamily: "'Cormorant Garamond', serif",

//                                     fontSize: '0.9rem',
//                                     lineHeight: '1.6',
//                                     color: theme.textMuted,
//                                     margin: 0,
//                                     fontWeight: '300',
//                                 }}>
//                                     {member.description}
//                                 </p> */}
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>


//             <button
//                 onClick={() => setOpenForm(true)}
//                 className="founder-cta-btn"
//                 style={{
//                     ...inlineStyles.pillBtn,
//                     backgroundColor: '#FFFFFF',
//                     color: '#2C302E',
//                     border: '1px solid rgba(44, 48, 46, 0.15)', // Subtle charcoal border
//                     padding: '12px 28px',
//                     borderRadius: '30px',
//                     fontSize: '0.9rem',
//                     fontWeight: '500',
//                     letterSpacing: '1.5px',
//                     textTransform: 'uppercase',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//                     outline: 'none',
                   
//                 }}
//                 onMouseEnter={(e) => {
//                     e.currentTarget.style.transform = 'scale(1.03)';
//                     e.currentTarget.style.backgroundColor = '#D4AF37'; // Your signature gold accent
//                     e.currentTarget.style.color = '#FFFFFF';
//                     e.currentTarget.style.borderColor = '#D4AF37';
//                 }}
//                 onMouseLeave={(e) => {
//                     e.currentTarget.style.transform = 'scale(1)';
//                     e.currentTarget.style.backgroundColor = '#FFFFFF'; // Returns back to clean white
//                     e.currentTarget.style.color = '#2C302E';
//                     e.currentTarget.style.borderColor = 'rgba(44, 48, 46, 0.15)';
//                 }}
//             >
//                 JOIN OUR TEAM
//             </button>

//             {/* ================= MODAL - NO-SCROLL SECURE FORM ================= */}
//             {
//                 openForm && (
//                     <div
//                         style={{
//                             position: "fixed",
//                             inset: 0,
//                             background: "rgba(44, 48, 46, 0.4)",
//                             backdropFilter: "blur(12px)",
//                             WebkitBackdropFilter: "blur(12px)",
//                             zIndex: 99999,
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             padding: "16px",
//                             boxSizing: "border-box"
//                         }}
//                     >
//                         {/* Modal Container */}
//                         <div
//                             className="modal-box"
//                             style={{
//                                 width: "100%",
//                                 maxWidth: "780px",
//                                 maxHeight: "calc(100vh - 32px)", // Dynamic viewport enforcement
//                                 background: theme.surface,
//                                 borderRadius: "24px",
//                                 boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
//                                 position: "relative",
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 animation: "modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
//                                 overflow: "hidden"
//                             }}
//                         >
//                             {/* Close Button */}
//                             <button
//                                 onClick={() => setOpenForm(false)}
//                                 aria-label="Close modal"
//                                 className="modal-close-btn"
//                                 style={{
//                                     position: "absolute",
//                                     top: "16px",
//                                     right: "16px",
//                                     width: "36px",
//                                     height: "36px",
//                                     borderRadius: "50%",
//                                     border: `1px solid ${theme.border}`,
//                                     background: theme.background,
//                                     cursor: "pointer",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     fontSize: "20px",
//                                     color: theme.textMain,
//                                     zIndex: 10,
//                                     transition: "all 0.2s"
//                                 }}
//                             >
//                                 &times;
//                             </button>

//                             {/* Scrollable interior containing form */}
//                             <div
//                                 style={{
//                                     padding: "36px",
//                                     overflowY: "auto",
//                                     flex: "1 1 auto",
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     gap: "24px"
//                                 }}
//                             >
//                                 {/* Header inside Form */}
//                                 <div>
//                                     <h2
//                                         style={{
//                                             margin: "0 0 8px 0",
//                                             fontSize: "28px",
//                                             color: theme.textMain,
//                                             fontWeight: "600",
//                                             letterSpacing: "-0.5px"
//                                         }}
//                                     >
//                                         Join Our Team
//                                     </h2>
//                                     <p
//                                         style={{
//                                             margin: 0,
//                                             color: theme.textMain,
//                                             fontSize: "14px",
//                                             lineHeight: "1.5"
//                                         }}
//                                     >
//                                         Become part of ST Interior and help us shape the future of luxury environments.
//                                     </p>
//                                 </div>

//                                 {/* Form Element - Two-Column Layout */}
//                                 <form
//                                     action="https://api.web3forms.com/submit"
//                                     method="POST"
//                                     encType="multipart/form-data"
//                                     style={{
//                                         display: "flex",
//                                         flexDirection: "column",
//                                         gap: "16px"
//                                     }}
//                                 >
//                                     <input
//                                         type="hidden"
//                                         name="access_key"
//                                         value="48cdcf48-2a69-4c0c-ab4f-b7435920f07e"
//                                     />

//                                     {/* Input Fields Grid */}
//                                     <div
//                                         className="modal-form-grid"
//                                         style={{
//                                             display: "grid",
//                                             gridTemplateColumns: "1fr 1fr",
//                                             gap: "16px"
//                                         }}
//                                     >
//                                         <input
//                                             type="text"
//                                             name="name"
//                                             placeholder="Full Name"
//                                             required
//                                             style={inputStyle}
//                                         />

//                                         <input
//                                             type="email"
//                                             name="email"
//                                             placeholder="Email Address"
//                                             required
//                                             style={inputStyle}
//                                         />

//                                         <input
//                                             type="tel"
//                                             name="phone"
//                                             placeholder="Phone Number"
//                                             style={inputStyle}
//                                         />

//                                         <input
//                                             type="text"
//                                             name="position"
//                                             placeholder="Position Applying For"
//                                             style={inputStyle}
//                                         />
//                                     </div>

//                                     <textarea
//                                         name="message"
//                                         placeholder="Tell us briefly about yourself..."
//                                         rows={3}
//                                         style={{
//                                             ...inputStyle,
//                                             resize: "none"
//                                         }}
//                                     />

//                                     {/* Resume Upload Box */}
//                                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                                         <label style={{ fontSize: "12px", fontWeight: "600", color: theme.textMain, textTransform: "uppercase" }}>
//                                             Upload CV (PDF, DOC)
//                                         </label>
//                                         <input
//                                             type="file"
//                                             name="attachment"
//                                             accept=".pdf,.doc,.docx"
//                                             style={{
//                                                 ...inputStyle,
//                                                 padding: "8px 12px"
//                                             }}
//                                         />
//                                     </div>

//                                     <button
//                                         type="submit"
//                                         className="modal-submit-btn"
//                                         style={{
//                                             ...inlineStyles.pillBtn,
//                                             backgroundColor: '#FFFFFF',
//                                             color: '#2C302E',
//                                             border: '1px solid rgba(44, 48, 46, 0.15)', // Subtle charcoal border
//                                             padding: '12px 28px',
//                                             borderRadius: '30px',
//                                             fontSize: '0.9rem',
//                                             fontWeight: '500',
//                                             letterSpacing: '1.5px',
//                                             textTransform: 'uppercase',
//                                             cursor: 'pointer',
//                                             transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//                                             outline: 'none'
//                                         }}
//                                         onMouseEnter={(e) => {
//                                             e.currentTarget.style.transform = 'scale(1.03)';
//                                             e.currentTarget.style.backgroundColor = '#D4AF37'; // Your signature gold accent
//                                             e.currentTarget.style.color = '#FFFFFF';
//                                             e.currentTarget.style.borderColor = '#D4AF37';
//                                         }}
//                                         onMouseLeave={(e) => {
//                                             e.currentTarget.style.transform = 'scale(1)';
//                                             e.currentTarget.style.backgroundColor = '#FFFFFF'; // Returns back to clean white
//                                             e.currentTarget.style.color = '#2C302E';
//                                             e.currentTarget.style.borderColor = 'rgba(44, 48, 46, 0.15)';
//                                         }}
//                                     >
//                                         Submit Application
//                                     </button>
//                                 </form>
//                             </div>

//                         </div>
//                     </div>
//                 )
//             }

//             {/* Global CSS Injectors for dynamic states and CSS-only interactions */}
//             <style>
//                 {`
//           /* Custom variables / interactions */
//           .founder-pulse-dot {
//             width: 8px;
//             height: 8px;
//             border-radius: 50%;
//             background: ${theme.accent};
//             animation: dotPulse 2s infinite ease-in-out;
//           }

//           .founder-cta-btn:hover {
//             background-color: ${theme.accent} !important;
//             transform: translateY(-3px) scale(1.02);
//             box-shadow: 0 12px 28px rgba(212,175,55,0.25) !important;
//           }

//           .founder-image-wrapper:hover img {
//             transform: scale(1.04);
//           }

//           .modal-close-btn:hover {
//             background-color: ${theme.textMain} !important;
//             color: #fff !important;
//             transform: rotate(90deg);
//           }

//           .modal-submit-btn:hover {
//             background-color: ${theme.accent} !important;
//             transform: translateY(-2px);
//           }

//           /* Hardware-accelerated Keyframe Animations */
//           @keyframes dotPulse {
//             0%, 100% { transform: scale(1); opacity: 1; }
//             50% { transform: scale(1.6); opacity: 0.4; }
//           }

//           @keyframes floatSlow {
//             0%, 100% { transform: translateY(0); }
//             50% { transform: translateY(-8px); }
//           }

//           @keyframes modalFadeIn {
//             from { opacity: 0; transform: scale(0.96) translateY(10px); }
//             to { opacity: 1; transform: scale(1) translateY(0); }
//           }

//           /* Media Query Engine */
//           @media (max-width: 991px) {
//             .founder-grid-container {
//               grid-template-columns: 1fr !important;
//               gap: 50px !important;
//             }
//           }

//           @media (max-width: 768px) {
//             .modal-form-grid {
//               grid-template-columns: 1fr !important;
//               gap: 12px !important;
//             }
//             .founder-floating-quote {
//               position: relative !important;
//               left: 0 !important;
//               bottom: 0 !important;
//               margin-top: 24px !important;
//               max-width: 100% !important;
//             }
//           }
//         `}
//             </style>

//         </section>
//     );
// };

// export default MeetOurTeam;

import React, { useState } from 'react';

// Import your team member images here (Replace with your actual paths)
import memberImg1 from '../Assets/Team/suhani3.jpeg';
import memberImg2 from '../Assets/Team/shraddha.jpeg';
import memberImg3 from '../Assets/Team/nakhat3.jpeg';

const MeetOurTeam = () => {
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  const [openForm, setOpenForm] = useState(false);

  const theme = {
    background: 'white',
    surface: '#FFFFFF',
    accent: '#D4AF37',
    textMain: '#2C302E',
    textMuted: '#7A827E',
    border: 'rgba(44, 48, 46, 0.08)',
    glass: 'rgba(255, 255, 255, 0.7)',
  };

  const teamMembers = [
    {
      name: 'Suhani Jain',
      role: 'Interior Designer',
      image: memberImg1,
      description:
        "Visionary designer steering the studio's spatial curation and artistic direction.",
    },
    {
      name: 'Shraddha Agrawal',
      role: 'Interior Designer',
      image: memberImg2,
      description:
        'Specialist in bespoke furniture engineering and structural spatial harmony.',
    },
    {
      name: 'Nakhat Giri',
      role: 'Site Supervisor',
      image: memberImg3,
      description:
        'Master of operational execution, translating blueprint concepts into immaculate reality.',
    },
  ];

  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '12px',
    border: `1px solid ${theme.border}`,
    outline: 'none',
    fontSize: '14px',
    background: theme.background,
    color: theme.textMain,
    boxSizing: 'border-box',
    transition: 'border-color 0.3s, box-shadow 0.3s',
    fontFamily: 'inherit',
  };

  const inlineStyles = {
    pillBtn: {
      padding: '14px 40px',
      fontSize: '1rem',
      fontWeight: '600',
      color: '#FFFFFF',
      backgroundColor: '#2C302E',
      border: 'none',
      borderRadius: '30px',
      cursor: 'pointer',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
      transition: 'all 0.2s ease',
      outline: 'none',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      display: 'inline-block',
      fontFamily: "'Cinzel', Georgia, serif",
    },
  };

  const responsiveStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&display=swap');

    @keyframes revealUp {
      from { opacity: 0; transform: translateY(50px); }
      to { opacity: 1; transform: translateY(0); }
    }
    
    @keyframes modalFadeIn {
      from { opacity: 0; transform: translateY(20px) scale(0.97); }
      to { opacity: 1; transform: translateY(0) scale(1); }
    }

    @keyframes dotPulse {
      0% { transform: scale(0.95); opacity: 0.8; }
      50% { transform: scale(1.2); opacity: 1; }
      100% { transform: scale(0.95); opacity: 0.8; }
    }

    .team-animate-entry { 
      animation: revealUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
    }

    .founder-pulse-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: ${theme.accent};
      animation: dotPulse 2s infinite ease-in-out;
    }

    .founder-cta-btn:hover {
      background-color: ${theme.accent} !important;
      transform: translateY(-3px) scale(1.02);
      box-shadow: 0 12px 28px rgba(212, 175, 55, 0.25) !important;
    }

    .modal-close-btn:hover {
      background-color: ${theme.textMain} !important;
      color: #ffffff !important;
      transform: rotate(90deg);
    }

    .modal-submit-btn:hover {
      background-color: ${theme.accent} !important;
      transform: translateY(-2px);
    }

    /* Responsive adjustments */
    @media (max-width: 991px) {
      .team-grid-container {
        grid-template-columns: 1fr !important;
        gap: 50px !important;
        padding: 0 20px !important;
      }
      .team-card-wrapper {
        margin-top: 0 !important;
        transform: none !important;
      }
      .team-title-main {
        font-size: 2.2rem !important;
        letter-spacing: 4px !important;
      }
      .team-image-frame {
        height: 400px !important;
      }
    }

    @media (max-width: 600px) {
      .modal-form-grid {
        grid-template-columns: 1fr !important;
      }
    }
  `;

  return (
    <section
      id="team"
      style={{
        width: '100vw',
        minHeight: '100vh',
        background: theme.background,
        padding: '160px 0 100px 0',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        fontFamily: "'Cinzel', Georgia, serif",
      }}
    >
      <style>{responsiveStyles}</style>

      {/* Editorial Section Header */}
      <div
        className="team-animate-entry"
        style={{
          textAlign: 'center',
          marginBottom: '90px',
          padding: '0 20px',
        }}
      >
        <span
          style={{
            fontFamily: 'system-ui, -apple-system, sans-serif',
            fontSize: '0.85rem',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '4px',
            color: theme.accent,
            display: 'block',
            marginBottom: '12px',
          }}
        >
          The Creative Minds
        </span>
        <h2
          className="team-title-main"
          style={{
            fontSize: 'calc(0.3rem + 1.5vw)',
            fontWeight: '400',
            textTransform: 'uppercase',
            letterSpacing: '6px',
            color: theme.textMain,
            margin: 0,
          }}
        >
          Meet Our Team
        </h2>
        <div
          style={{
            width: '60px',
            height: '1px',
            background: theme.accent,
            margin: '24px auto 0 auto',
          }}
        />
      </div>

      {/* Asymmetric Staggered Grid */}
      <div
        className="team-grid-container"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '30px',
          width: '100%',
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 40px',
          boxSizing: 'border-box',
        }}
      >
        {teamMembers.map((member, index) => {
          const isHovered = hoveredCardIndex === index;
          const isEvenColumn = index % 2 === 1;
          const topOffset = isEvenColumn ? '60px' : '0px';

          return (
            <div
              key={index}
              className="team-card-wrapper team-animate-entry"
              onMouseEnter={() => setHoveredCardIndex(index)}
              onMouseLeave={() => setHoveredCardIndex(null)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: topOffset,
                transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
                transform: isHovered ? 'translateY(-10px)' : 'translateY(0)',
                animationDelay: `${index * 0.15}s`,
              }}
            >
              {/* Image Frame */}
              <div
                className="team-image-frame"
                style={{
                  width: '100%',
                  height: '480px',
                  overflow: 'hidden',
                  position: 'relative',
                  border: `1px solid ${
                    isHovered ? theme.accent : theme.border
                  }`,
                  transition: 'border-color 0.4s ease',
                  background: '#F5F5F5',
                }}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition:
                      'transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
                    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '4px',
                    background: theme.accent,
                    transform: isHovered ? 'scaleX(1)' : 'scaleX(0)',
                    transformOrigin: 'left',
                    transition: 'transform 0.4s ease',
                  }}
                />
              </div>

              {/* Info Details */}
              <div
                style={{
                  padding: '24px 4px 0 4px',
                  textAlign: 'left',
                }}
              >
                <h3
                  style={{
                    fontFamily: "'Cinzel', Georgia, serif",
                    fontSize: '1.35rem',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    color: theme.textMain,
                    margin: '0 0 6px 0',
                    letterSpacing: '3px',
                  }}
                >
                  {member.name}
                </h3>
                <span
                  style={{
                    fontFamily: "'Cinzel', Georgia, serif",
                    fontSize: '0.8rem',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    color: theme.accent,
                    display: 'block',
                    marginBottom: '14px',
                  }}
                >
                  {member.role}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* CTA Button Wrapper */}
      <div style={{ textAlign: 'center', marginTop: '80px' }}>
        <button
          onClick={() => setOpenForm(true)}
          className="founder-cta-btn"
          style={{
            ...inlineStyles.pillBtn,
            backgroundColor: '#FFFFFF',
            color: '#2C302E',
            border: '1px solid rgba(44, 48, 46, 0.15)',
            padding: '12px 28px',
            borderRadius: '30px',
            fontSize: '0.9rem',
            fontWeight: '500',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
            outline: 'none',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.03)';
            e.currentTarget.style.backgroundColor = theme.accent;
            e.currentTarget.style.color = '#FFFFFF';
            e.currentTarget.style.borderColor = theme.accent;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.backgroundColor = '#FFFFFF';
            e.currentTarget.style.color = '#2C302E';
            e.currentTarget.style.borderColor = 'rgba(44, 48, 46, 0.15)';
          }}
        >
          JOIN OUR TEAM
        </button>
      </div>

      {/* Modal - No-Scroll Secure Form */}
      {openForm && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(44, 48, 46, 0.4)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            zIndex: 99999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '16px',
            boxSizing: 'border-box',
          }}
        >
          <div
            className="modal-box"
            style={{
              width: '100%',
              maxWidth: '780px',
              maxHeight: 'calc(100vh - 32px)',
              background: theme.surface,
              borderRadius: '24px',
              boxShadow: '0 25px 60px rgba(0,0,0,0.15)',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              animation: 'modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
              overflow: 'hidden',
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setOpenForm(false)}
              aria-label="Close modal"
              className="modal-close-btn"
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                border: `1px solid ${theme.border}`,
                background: theme.background,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                color: theme.textMain,
                zIndex: 10,
                transition: 'all 0.2s',
              }}
            >
              &times;
            </button>

            {/* Scrollable Interior */}
            <div
              style={{
                padding: '36px',
                overflowY: 'auto',
                flex: '1 1 auto',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
              }}
            >
              <div>
                <h2
                  style={{
                    margin: '0 0 8px 0',
                    fontSize: '28px',
                    color: theme.textMain,
                    fontWeight: '600',
                    letterSpacing: '-0.5px',
                  }}
                >
                  Join Our Team
                </h2>
                <p
                  style={{
                    margin: 0,
                    color: theme.textMain,
                    fontSize: '14px',
                    lineHeight: '1.5',
                  }}
                >
                  Become part of ST Interior and help us shape the future of
                  luxury environments.
                </p>
              </div>

              <form
                action="https://api.web3forms.com/submit"
                method="POST"
                encType="multipart/form-data"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <input
                  type="hidden"
                  name="access_key"
                  value="48cdcf48-2a69-4c0c-ab4f-b7435920f07e"
                />

                <div
                  className="modal-form-grid"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '16px',
                  }}
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    required
                    style={inputStyle}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                    style={inputStyle}
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    style={inputStyle}
                  />
                  <input
                    type="text"
                    name="position"
                    placeholder="Position Applying For"
                    style={inputStyle}
                  />
                </div>

                <textarea
                  name="message"
                  placeholder="Tell us briefly about yourself..."
                  rows={3}
                  style={{
                    ...inputStyle,
                    resize: 'none',
                  }}
                />

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                  }}
                >
                  <label
                    style={{
                      fontSize: '12px',
                      fontWeight: '600',
                      color: theme.textMain,
                      textTransform: 'uppercase',
                    }}
                  >
                    Upload CV (PDF, DOC)
                  </label>
                  <input
                    type="file"
                    name="attachment"
                    accept=".pdf,.doc,.docx"
                    style={{
                      ...inputStyle,
                      padding: '8px 12px',
                    }}
                  />
                </div>

                <button
                  type="submit"
                  className="modal-submit-btn"
                  style={{
                    ...inlineStyles.pillBtn,
                    backgroundColor: '#FFFFFF',
                    color: '#2C302E',
                    border: '1px solid rgba(44, 48, 46, 0.15)',
                    padding: '12px 28px',
                    borderRadius: '30px',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                    outline: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.03)';
                    e.currentTarget.style.backgroundColor = theme.accent;
                    e.currentTarget.style.color = '#FFFFFF';
                    e.currentTarget.style.borderColor = theme.accent;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = '#FFFFFF';
                    e.currentTarget.style.color = '#2C302E';
                    e.currentTarget.style.borderColor =
                      'rgba(44, 48, 46, 0.15)';
                  }}
                >
                  Submit Application
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MeetOurTeam;